import {http} from '../../shared/services';

export const LOAD_STATE_MANDATE = 'LOAD_STATE_MANDATE';
export const LOAD_STATE_MANDATE_PENDING = `${LOAD_STATE_MANDATE}_PENDING`;
export const LOAD_STATE_MANDATE_FULFILLED = `${LOAD_STATE_MANDATE}_FULFILLED`;
export const LOAD_STATE_MANDATE_REJECTED = `${LOAD_STATE_MANDATE}_REJECTED`;

export function loadStateMandate(userId, characterId, state) {
  return {
    type: LOAD_STATE_MANDATE,
    payload: http.get(`state_mandate?user_id=${userId}&character_id=${characterId}&state=${state}`),
  };
}



// WEBPACK FOOTER //
// ./app/features/stateMandates/actions/loadStateMandate.js